const PREFIF = "savings_line_item";

export const SAVINGS_LINE_ITEM_TEST_IDS = {
    CONTAINER: `${PREFIF}_container`,
    TITLE: `${PREFIF}_title`,
    SUBTITLE: `${PREFIF}_subtitle`,
    ICON: `${PREFIF}_icon`,
    RIGHT_SECTION: `${PREFIF}_right_section`,
    BOTTOM_TEXT: `${PREFIF}_bottom_text`,
    COUPON_CODE_LIST: `${PREFIF}_coupon_code_list`,
    COUPON_CODE_LIST_ITEM: `${PREFIF}_coupon_code_list_item_{0}`,
    COUPON_CODE_LIST_ITEM_APPLIED: `${PREFIF}_coupon_code_list_item_applied_{0}`,
    TOOLTIP: `${PREFIF}_tooltip`,
};

export const SAVINGS_CORNER_TEXT_CONTAINER = "savings_corner_text_container";
export const SAVINGS_V2_CONTAINER = "savings_v2_container";
